import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory  } from "react-router-dom";

import { findElementBranch } from '../../../api/branch';
import { takeBookingOrHotelInvoiceByID } from '../../../api/booking';
import { takeServiceSI, saveServiceSI, checkNumberLateSi, takeServiceSIHistory, 
            updateNewVersionServiceSI, takeServiceSIWithVersion, saverequestNewServiceSI } from '../../../api/invoice';
import { getToday } from '../../../utils/Date/SupportDate';
import { unitsAction } from '../../../redux/actions/index';
import { modalAction } from '../../../redux/actions';
import ModalSupportOption from '../../Unit/Modal/modalSupportOption';

// import { unitsAction } from '../../../redux/actions';
import NumberFormat from 'react-number-format';
import { informationToast, errorToast, } from '../../../utils/Toast/index'; // warningToast
import FooterButton from "../../../utils/FooterButton";

import './makeService.css';

function MakeServiceInvoice() {
    const history = useHistory();
    const dispatch = useDispatch();
    const token = useSelector(state => state.token);
    const dataParams = useParams();
    const auth = useSelector(state => state.auth);
    //const { branchID } = auth.user;

    const branchID = dataParams.branchID || auth.user.branchID;
    const versionParam = dataParams.version ? Number(dataParams.version) : null;
    // const { idRoom } = useParams();
    const [data, setDate] = useState({
        date: getToday(),
        invoice_id: 0,
        version: 1,
        lastVersion: 1,
        name: "",
        room: "",
        service: "",
        staffCode: "",
        quantity: 1,
        price: "",
        edit: true,
        vnd: "",
        usd: "",
        jpy: "",
        card: "",
        transfer: "",
        receptionist: "",
        isDebit: false,
        });

    const isView = !data.edit//dataParams.branchID ? true : false;
    const [branchData, setBranchData] = useState({
        rateYen: 150,
        rateUSD: 250000,
        name: "Azumaya",
        address: "",
        phone: "",
        listStaffCodeMassage: [],
        signature: [],
    });
    const [showServiceList, setShowServiceList] = useState(false);
    const [bookingId, setBookingId] = useState("");
    const [lateInvocie, setLateInvoice] = useState(0)
    // const [errorSerachBooking, setErrorSearchBooking] = useState("");
    const [listService, setListService] = useState([])
    const [filterText, setFilterText] = useState("");
    const [paymentMethod, setPaymentMethod] = useState("");
    const [versionHistory, setVersionHistory] = useState([]);
    const [showVersionHistory, setShowVersionHistory] = useState(false);
    
    useEffect(() => {
        const loadListService = async () => {
            try {
                dispatch(unitsAction.showLoading());
                const result = await findElementBranch(branchID, "service_invoice", token);
                const lateInvoice = await checkNumberLateSi(branchID, token);
               // console.log("result", result)
                if(result) {
                    setListService(result.data.data);
                    setLateInvoice(lateInvoice.data.data);
                    setBranchData({
                        listStaffCodeMassage: result.data.listStaffCodeMassage,
                        signature: result.data.signature,
                        rateYen: result.data.rate.rateYen,
                        rateUSD: result.data.rate.rateUSD,
                        name: result.data.name,
                        address: result.data.address,
                        phone: result.data.phone,
                    })

                }

                if(dataParams.idRoom) {
                    // If version param exists, load specific version, otherwise load latest
                    const result2 = versionParam 
                        ? await takeServiceSIWithVersion(branchID, dataParams.idRoom, versionParam, token)
                        : await takeServiceSI(branchID, dataParams.idRoom, token);
                    
                    if(result2 && result2.data && result2.data.data) {
                        setDate({
                            ...result2.data.data
                        })
                        // Load version history
                        const historyRes = await takeServiceSIHistory(branchID, result2.data.data.invoice_id, token);
                        if(historyRes && historyRes.data && historyRes.data.status === 1) {
                            setVersionHistory(historyRes.data.data || []);
                        }
                    }
                }
                dispatch(unitsAction.hiddenLoading());
            } catch (error) {
                console.error("Error loading service invoice data:", error);
                dispatch(unitsAction.hiddenLoading());
            }
        }

        if(branchID && token) {
            loadListService();
        }
       
    }, [branchID, token, dataParams.idRoom, dispatch, versionParam])

    function loadDataGuestByRequest() {
        //takeBookingOrHotelInvoiceByID

        const loadDataGuest = async () => {
            const result = await takeBookingOrHotelInvoiceByID(branchID, bookingId, token );
            if(result) {
                if(result.data.status === 1) {
                    const newData = {...data};
                    newData.name = result.data.data.name;
                    newData.room = result.data.data.roomSelect;
                    setDate(newData)
                } else errorToast(result.data.msg)

            } else errorToast("Error when load data")
        }

        loadDataGuest();
    }

    function handleSelectPayment(method) {
        setPaymentMethod(method);

        const newData = { ...data };
        const priceWithQuantity = data.price * data.quantity;
        newData.vnd = method === "vnd" ? priceWithQuantity : "";
        newData.usd = method === "usd" ? Math.round(( priceWithQuantity / branchData.rateUSD)*100)/100 : "";
        newData.jpy = method === "jpy" ?Math.round( priceWithQuantity  / branchData.rateYen): "";
        newData.card = method === "card" ? priceWithQuantity : "";
        newData.transfer = method === "transfer" ? priceWithQuantity : "";

        setDate(newData);
    }

    function onPrintNewNumberServiceInvoice() {
        const saveNewService = async () => {
            dispatch(unitsAction.showLoading());
            let result;
            const dataUpdate = {
                ...data,
                edit: false,
                vnd: parseVietnameseCurrency(data.vnd),
                usd: parseVietnameseCurrency(data.usd),
                jpy: parseVietnameseCurrency(data.jpy),
                card: parseVietnameseCurrency(data.card),
                price: parseVietnameseCurrency(data.price),
                transfer: parseVietnameseCurrency(data.transfer),
            }

            if(versionParam) {
                window.print();
               result =  await saveServiceSI(branchID, dataUpdate, token);
            } else result = await saverequestNewServiceSI(branchID, dataUpdate, token);
            
            if(result) {    
                if(result.data.status === 1) {
                    if(!versionParam) history.push("/service_invoice/"+branchID+"/"+result.data.invoice_id +"/1");
                    else history.push("/service_invoice/"+branchID+"/"+result.data.data.invoice_id +"/"+ result.data.data.version);
                    setDate({...result.data.data})
                    dispatch(unitsAction.hiddenLoading());
                   if(!versionParam) window.print();
                   window.location.reload();
                }
                else errorToast("" + result.data.status);
            } else errorToast("Error when print invoice")

            dispatch(unitsAction.hiddenLoading());
           // console.log("result", result) 
        }

        // if(dataParams.idRoom)  {
        //     window.scrollTo(0, 0);
        //     window.print();
        // }
        if(!data.edit) {
            window.scrollTo(0, 0);
            window.print();
        }
        else saveNewService(); 
    }

    function parseVietnameseCurrency(str) {
        if (str === null || str === undefined) return 0;
        const cleanString = String(str).replace(/[^0-9]/g, ''); 
        return Number(cleanString) || 0; 
    }

    function isDiscountedMassage(service) {
        return service;
    }

    function updatePaymentAmounts(invoiceData) {
        if (!paymentMethod) return;

        const total = parseVietnameseCurrency(invoiceData.price) * Number(invoiceData.quantity || 0);
        invoiceData.vnd = paymentMethod === "vnd" ? total : "";
        invoiceData.usd = paymentMethod === "usd" ? Math.round((total / branchData.rateUSD) * 100) / 100 : "";
        invoiceData.jpy = paymentMethod === "jpy" ? Math.round(total / branchData.rateYen) : "";
        invoiceData.card = paymentMethod === "card" ? total : "";
        invoiceData.transfer = paymentMethod === "transfer" ? total : "";
    }

    function updateMassageDiscount(invoiceData, previousPrice, previousRoom) {
        const serviceName = invoiceData.service;
        if (!isDiscountedMassage(serviceName)) return;

        const shouldDiscount = Boolean(String(invoiceData.room || "").trim());
        const wasDiscounted = Boolean(String(previousRoom || "").trim());
        const catalogService = listService.find(item => item.value.trim() === serviceName);
        const basePrice = catalogService
            ? parseVietnameseCurrency(catalogService.price)
            : shouldDiscount && !wasDiscounted
                ? parseVietnameseCurrency(previousPrice)
                : !shouldDiscount && wasDiscounted
                    ? Math.round(parseVietnameseCurrency(previousPrice) / 0.9)
                    : parseVietnameseCurrency(previousPrice);

        invoiceData.price = shouldDiscount ? Math.round(basePrice * 0.9) : basePrice;
        updatePaymentAmounts(invoiceData);
    }

    function onSaveServiceInvoice() {
        const saveServiceInvoice = async () => {
            const resultSaveInvoice = await saveServiceSI(branchID, {
                ...data,
                vnd: parseVietnameseCurrency(data.vnd),
                usd: parseVietnameseCurrency(data.usd),
                jpy: parseVietnameseCurrency(data.jpy),
                card: parseVietnameseCurrency(data.card),
                price: parseVietnameseCurrency(data.price),
                transfer: parseVietnameseCurrency(data.transfer),
            }, token);
            if(resultSaveInvoice) {
                if(resultSaveInvoice.data.status === 1) {
                    setDate({...resultSaveInvoice.data.data});
                    informationToast("Save service invoice successfully");
                } else errorToast("" + resultSaveInvoice.data.msg);
            } else errorToast("Error when save service invoice")
        }

        saveServiceInvoice();
    }

    function onPrintTranferNewLink() {
        window.location.href = "/service_invoice"
    }

    function onRequestEdit() {
        const closeModal = () => { dispatch(modalAction.modalReset()); }
        const openModal = () => { dispatch(modalAction.modalIsOk()); }

        const onConfirm = async () => {
            // create new service invoice (version) and redirect to it for editing
            try {
                dispatch(unitsAction.showLoading());
                const result = await updateNewVersionServiceSI(branchID, data.invoice_id, data, token);
                dispatch(unitsAction.hiddenLoading());
                if (result && result.data && result.data.status === 1) {
                    closeModal();
                    informationToast("New version created: v" + result.data.version);
                    setDate(result.data.data);
                    history.push("/service_invoice/" + branchID + "/" + result.data.invoice_id + "/" + result.data.version);
                } else {
                    errorToast(result && result.data && result.data.msg ? result.data.msg : 'Error when request edit');
                }
            } catch (err) {
                dispatch(unitsAction.hiddenLoading());
                errorToast('Error when request edit');
            }
        }

        dispatch(modalAction.modalChange({
            type: "centered",
            title: "Request Edit - Create New Version",
            size: 'xs',
            content: <ModalSupportOption
                type={89}
                button1="Confirm"
                button3="Cancel"
                itemOption={{ color: "black", title: "This action will create a new version of this Service Invoice. Proceed?" }}
                featureButton1={onConfirm}
                featureButton3={closeModal}
            />
        }));

        openModal();
    }

    function onChange(value, target, options) {
        const newData = { ...data };

        if(options === "changeVisitor") {
            newData["room"] = "";
            updateMassageDiscount(newData, data.price, data.room);
        }
        if (target === "service-item") {
            const serviceName = value;
            const shouldDiscount = Boolean(String(newData.room || "").trim()) && isDiscountedMassage(serviceName);
            newData["service"] = serviceName;
            newData["price"] = shouldDiscount
                ? Math.round(parseVietnameseCurrency(options) * 0.9)
                : options;
            updatePaymentAmounts(newData);
        } else if (target === "room") {
            newData[target] = value;
            updateMassageDiscount(newData, data.price, data.room);
        } else if (target === "service") {
            newData[target] = value;
            if (isDiscountedMassage(value)) {
                updateMassageDiscount(newData, data.price, data.room);
            }
        } else if(target === "vnd" ) {
            const priceWithQuantity = data.price * data.quantity;
            newData[target] = value;
            newData["card"] = priceWithQuantity - parseVietnameseCurrency(value);
        } else if (target === "staffCodeQuick") {
            const staffCodes = newData.staffCode ? newData.staffCode.split(" + ") : [];
            staffCodes.push(value);
            newData.staffCode = staffCodes.join(" + ");
            newData.quantity = Math.max(Number(newData.quantity) || 0, staffCodes.length);
            updatePaymentAmounts(newData);
        } else if(target === "quantity") {
            newData[target] = value;
            updatePaymentAmounts(newData);
        } else if (target === "price") {
            newData[target] = value;
            updatePaymentAmounts(newData);
        } else newData[target] = value;

        setDate(newData);
    }


    const printStyle = `
        .printer {
            display: none;
        }

        .d-flex .printer {
            display: none;
        }
        @media print {
            @page {
                size: vertical;
                margin: 10mm;
            }

            .no-printer {
                display: none !important;
            }

            .printer {
                display: block !important;
            }
        }
    `;

    return (
        <>
            <style>{printStyle}</style>
            <div className="d-flex" style={{ flex: '10', width: '750px', marginBottom: '50px' }}>
                <div className="SI" style={{ flex: '9' }}>
                    <h1 className="SI_name no-printer" style={{ color: '#5f497a' }}>MAKE SERVICE INVOICE SYSTEM</h1>
                    <div className="SI_header d-flex justify-content-between mt-5" style={{ width: '1000px' }}>
                        <div className="d-flex">
                            <div style={{ width: '100%', }} align="right">
                                <img
                                    style={{ width: '170px' }}
                                    src="https://database.azumayareport.com/img/logo/logo_az.png" 
                                    className="img-responsive logo"
                                    alt="image-logo" ></img>
                            </div>
                            <div style={{ textAlign: "left" }}>
                                <div style={{ fontSize: '1.6rem', width: '300px', fontWeight: '500' }}>AZUMAYA {branchData.name.toUpperCase()} HOTEL</div>
                                <div style={{ fontSize: '1.3rem', width: '400px' }}>Add: {branchData.address}</div>
                                <div style={{ fontSize: '1.3rem' }}>Tel: {branchData.phone}</div>
                            </div>
                        </div>
                        <div style={{ fontSize: '2rem' }}>
                            <div>
                                <span>Invoice Number:</span>
                                <strong className={dataParams.idRoom ? "ml-2" : "ml-2 red-color"}>
                                    {dataParams.idRoom ? data.invoice_id :  "Waiting" }
                                </strong>
                                {dataParams.idRoom && <span style={{fontSize: '2rem', color: '#0066cc', marginLeft: '2px'}}>({data.version || 1})</span>}
                            </div>
                            <div className="no-print" style={{fontSize:"1.5rem", color: "#d800ff"}}>
                                <span>(Late Invoice:</span>
                                <strong className="ml-1"> {lateInvocie})</strong>
                            </div>
                        </div>
                    </div>
                    <div className="SI_name" style={{ fontSize: '3rem', fontWeight: '600' }}>SERVICE INVOICE</div>
                    {isView && versionHistory.length > 0 && (
                        <div className="no-print" style={{marginTop: '10px', marginBottom: '10px'}}>
                            <button className="btn btn-sm btn-outline-secondary" onClick={() => setShowVersionHistory(!showVersionHistory)}>
                                {showVersionHistory ? 'Hide' : 'Show'} Version History ({versionHistory.length})
                            </button>
                            {showVersionHistory && (
                                <div style={{marginTop: '10px', padding: '10px', backgroundColor: '#f0f0f0', borderRadius: '4px', maxHeight: '200px', overflowY: 'auto'}}>
                                    {versionHistory.map((v, idx) => (
                                        <div key={idx} style={{padding: '5px', borderBottom: '1px solid #ddd', cursor: 'pointer'}} 
                                            onClick={() => history.push(`/service_invoice/${branchID}/${v.invoice_id}/${v.version}`)}>
                                            <strong>V{v.version}</strong> - {new Date(v.createdAt).toLocaleString()} | {v.service} ({v.vnd || v.price})
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}
                    {!isView && <div className="no-print justify-content-center d-flex">
                        <input 
                            value={bookingId}
                            onChange={e => setBookingId(e.target.value)}
                            style={{width:"200px"}}
                            className="p-2"
                            placeholder="Enter booking id"
                        />
                        <button className="btn btn-success ml-2" 
                            onClick={() => loadDataGuestByRequest()}>Check Guest Data</button>
                    </div>}
                    <div className="SI_content">
                        <div className="SI_content-item">
                            <label className="label">Guest's name:</label>
                            <input className="input"
                                disabled={isView}
                                value={data.name.toLocaleUpperCase()}
                                onChange={e => onChange(e.target.value, "name")} />

                            {!isView && <button className="no-print btn btn-primary" 
                            onClick={() => onChange("Visitor", "name", "changeVisitor")}>Visitor</button>}
                        </div>
                        <div className={data.name.toUpperCase() === "VISITOR" ? "op-hidden" : "SI_content-item"}>
                            <label className="label">Room number:</label>
                            <input className="input" value={data.room}
                                disabled={isView}
                                onChange={e => onChange(e.target.value, "room")} />
                        </div>
                        <div className="SI_content-item d-flex">
                            <label className="label" style={{width:"240px"}}>Service:</label>
                            <div className="service-wrapper">
                                
                                {/* Input gõ tự do */}
                                <input
                                    className="input"
                                    disabled={isView}
                                    value={data.service}
                                    placeholder="Enter service..."
                                    onFocus={() => setShowServiceList(true)}
                                    onBlur={() => setTimeout(() => setShowServiceList(false), 120)}
                                    onChange={e => {
                                        onChange(e.target.value, "service");
                                        setFilterText(e.target.value.toLowerCase());
                                    }}
                                />
                                {/* Dropdown autocomplete */}
                                {showServiceList && (
                                    <div className="service-grid">

                                        {/* Cột trái */}
                                        <div className="service-column">
                                            {listService.slice(0, 5)
                                                .filter(item => item.value.toLowerCase().includes(filterText))
                                                .map((item, index) => (
                                                    <div
                                                        key={index}
                                                        className="service-item"
                                                        onMouseDown={() => {
                                                       //     onChange(item.value, "service");
                                                            onChange(item.value, "service-item",item.price );
                                                            setFilterText("");
                                                        }}
                                                    >
                                                        {item.value} ({item.price.toLocaleString()})
                                                    </div>
                                                ))
                                            }
                                        </div>

                                        {/* Cột phải */}
                                        <div className="service-column">
                                            {listService.slice(5)
                                                .filter(item => item.value.toLowerCase().includes(filterText))
                                                .map((item, index) => (
                                                    <div
                                                        key={index + 5}
                                                        className="service-item"
                                                        onMouseDown={() => {
                                                            onChange(item.value,  "service-item",item.price );
                                                            setFilterText("");
                                                        }}
                                                    >
                                                        {item.value} ({item.price})
                                                    </div>
                                                ))
                                            }
                                        </div>

                                    </div>
                                )}

                            </div>
                        </div>
                        {data.service.includes("Massage") && <div className="SI_content-item">
                            <label className="label">Staff Code:</label>
                            <input className="input"
                                disabled={isView}
                                value={data.staffCode}
                                onChange={e => onChange(e.target.value, "staffCode")} />

                        </div>}

                        {!isView && data.service.includes("Massage") && (
                            <div className="number-btn-group" style={{ display: 'flex', gap: '5px', flexWrap: 'wrap',paddingLeft: '230px', paddingBottom: '2px' }}>
                                {branchData.listStaffCodeMassage.map((num) => (
                                    <button
                                        key={num}
                                        type="button" // Tránh việc button tự động submit form nếu nằm trong thẻ <form>
                                        className="btn-quick-select no-print"
                                        style={{
                                            padding: '4px 8px',
                                            cursor: 'pointer',
                                            backgroundColor: String(data.staffCode || "").split(" + ").includes(String(num)) ? '#007bff' : '#f0f0f0',
                                            color: String(data.staffCode || "").split(" + ").includes(String(num)) ? '#fff' : '#000',
                                            border: '1px solid #ccc',
                                            borderRadius: '4px'
                                        }}
                                        onClick={() => onChange(num.toString(), "staffCodeQuick")} // Khi click sẽ cập nhật giá trị vào staffCode
                                    >
                                        {num}
                                    </button>
                                ))}
                            </div>
                        )}
                        
                        <div className="SI_content-item">
                            <label className="label">Price:</label>
                            <NumberFormat
                                className="input"
                                disabled={isView}
                                thousandSeparator={true}
                                type="text"
                                min="0"
                                value={data.price}
                                onChange={e => onChange(e.target.value, "price")}
                            />
                        </div>
                        <div className={"SI_content-item"}>
                            <label className="label">Quantity:</label>
                            <NumberFormat
                                className="input"
                                disabled={isView}
                                thousandSeparator={true}
                                type="text"
                                min="0"
                                value={data.quantity}
                                onChange={e => onChange(e.target.value, "quantity")}
                            />
                        </div>
                    </div>
                    <div className="SI_total">
                        <div style={{
                            // border: '1px solid black',
                            borderBottom: '0',
                            textAlign: 'left',
                            padding: '8px',
                            paddingLeft: '50px',
                            fontWeight: '600'
                        }}>TOTAL</div>
                        <div className="d-flex SI_total-content" style={{ flex: 9 }}>
                            <div style={{ flex: 2, border: '1px solid black', textAlign: 'left', paddingLeft: '50px', alignItems: 'center', borderRight: '0' }}>
                                <div style={{ 
                                    fontWeight: '600', 
                                    margin: 'auto', 
                                    paddingRight: data.isDebit ? '' : '25px',
                                    paddingTop: data.isDebit  ? '41px' : '35%', 
                                }}>PAYMENT TERM</div>
                            </div>

                            {
                                data.isDebit ? <div style={{ flex: 7, borderTop: '1px solid', borderRight: '1px solid', borderLeft: '1px solid',   }}>
                                        <div className="SI_total-content-item" style={{ border: 0, borderBottom: '1px solid black' }}>
                                            <label className="label" style={{textAlign:'left', width: '120px', padding: '42px    '}}>DEBIT</label>
                                            <input
                                                type="checkbox"
                                                name="pay_method"
                                                className="no-print"
                                                checked={data.isDebit}
                                                onChange={() => setDate({...data, isDebit: !data.isDebit})}
                                                style={{ marginRight: "30px" }}
                                            />
                                        </div>

                                    </div> :
                                <div style={{ flex: 7, border: '1px solid black' }}>

                                    {/* VND */}
                                    <div className="SI_total-content-item" style={{ border: 0, borderBottom: '1px solid black' }}>
                                        <label className="label"><span className="no-print" style={{fontSize:"1.5rem", color: "#482979"}}>(Autofill on Card)</span>VND</label>

                                        <input
                                            type="radio"
                                            name="pay_method"
                                            className="no-print"
                                            checked={paymentMethod === "vnd"}
                                            onChange={() => handleSelectPayment("vnd")}
                                            style={{ marginRight: "10px" }}
                                        />

                                        <NumberFormat
                                            className="input"
                                            thousandSeparator={true}
                                            type="text"
                                            disabled={isView}
                                            value={data.vnd}
                                            onChange={e => onChange(e.target.value, "vnd")}
                                        />
                                    </div>

                                    {/* USD */}
                                    <div className="SI_total-content-item" style={{ border: 0, borderBottom: '1px solid black' }}>
                                        <label className="label">USD</label>

                                        <input
                                            type="radio"
                                            name="pay_method"
                                            className="no-print"
                                            checked={paymentMethod === "usd"}
                                            onChange={() => handleSelectPayment("usd")}
                                            style={{ marginRight: "10px" }}
                                        />

                                        <NumberFormat
                                            className="input"
                                            thousandSeparator={true}
                                            type="text"
                                            disabled={isView}
                                            value={data.usd}
                                            onChange={e => onChange(e.target.value, "usd")}
                                        />
                                    </div>

                                    {/* JPY */}
                                    <div className="SI_total-content-item" style={{ border: 0, borderBottom: '1px solid black' }}>
                                        <label className="label">JPY</label>

                                        <input
                                            type="radio"
                                            name="pay_method"
                                            className="no-print"
                                            checked={paymentMethod === "jpy"}
                                            onChange={() => handleSelectPayment("jpy")}
                                            style={{ marginRight: "10px" }}
                                        />

                                        <NumberFormat
                                            className="input"
                                            thousandSeparator={true}
                                            type="text"
                                            disabled={isView}
                                            value={data.jpy}
                                            onChange={e => onChange(e.target.value, "jpy")}
                                        />
                                    </div>

                                    {/* CREDIT CARD */}
                                    <div className="SI_total-content-item" style={{ border: 0, borderBottom: '1px solid black' }}>
                                        <label className="label">CREDIT CARD</label>

                                        <input
                                            type="radio"
                                            name="pay_method"
                                            className="no-print"
                                            checked={paymentMethod === "card"}
                                            onChange={() => handleSelectPayment("card")}
                                            style={{ marginRight: "10px" }}
                                        />

                                        <NumberFormat
                                            className="input"
                                            thousandSeparator={true}
                                            type="text"
                                            disabled={isView}
                                            value={data.card}
                                            onChange={e => onChange(e.target.value, "card")}
                                        />
                                    </div>

                                    {/* TRANSFER */}
                                    <div className="SI_total-content-item" style={{ border: 0, borderBottom: '1px solid black' }}>
                                        <label className="label">TRANSFER</label>

                                        <input
                                            type="radio"
                                            name="pay_method"
                                            className="no-print"
                                            checked={paymentMethod === "transfer"}
                                            onChange={() => handleSelectPayment("transfer")}
                                            style={{ marginRight: "10px" }}
                                        />

                                        <NumberFormat
                                            className="input"
                                            thousandSeparator={true}
                                            type="text"
                                            disabled={isView}
                                            value={data.transfer}
                                            onChange={e => onChange(e.target.value, "transfer")}
                                        />
                                    </div>

                                     {/* DEBIT */}
                                    <div className="SI_total-content-item no-print" style={{ border: 0 }}>
                                        <label className="label">DEBIT</label>

                                        <input
                                            type="checkbox"
                                            name="pay_method"
                                            className="no-print"
                                            checked={data.isDebit}
                                            onChange={() => setDate({...data, isDebit: !data.isDebit})}
                                            style={{ marginRight: "10px" }}
                                        />
                                    </div>

                                </div>
                            }
                        </div>
                    </div>
                    <div className="SI_footer justify-content-between">
                        <div className="SI_footer-item">
                            <div className="d-flex">
                                <label className="label">Date:</label>
                                <input className="input no-printer" type="date" value={data.date}
                                    onChange={e => onChange(e.target.value, "date")}
                                    disabled={isView}
                                    style={{ width: '230px', textAlign: 'center' }} />
                                <div className="input hidden printer" style={{ width: '230px', textAlign: 'center' }}>{data?.date}</div>
                            </div>
                            <div className="mt-4">
                                <label className="label ">Receptionist:</label>
                                <input className="input" value={data.receptionist} 
                                       onChange={e => setDate({...data, receptionist: e.target.value.toLocaleUpperCase()})}
                                       style={{textAlign: 'center'}} disabled={isView} />
                            </div>
                         </div>
                        <div className="SI_footer-item mt-4">
                            <label className="label" style={{ width: '40%' }}>Guest's signature:</label>
                            <input className="input" style={{ width: '70%' }} disabled={isView}/>
                        </div>
                    </div>

                    {!isView && (
                        <div className="number-btn-group" style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
                            {branchData.signature.map((num) => (
                                <button
                                    key={num}
                                    type="button" // Tránh việc button tự động submit form nếu nằm trong thẻ <form>
                                    className="btn-quick-select"
                                    style={{
                                        padding: '4px 8px',
                                        cursor: 'pointer',
                                        backgroundColor: String(data.staffCode || "").split(" + ").includes(String(num)) ? '#007bff' : '#f0f0f0',
                                        color: String(data.staffCode || "").split(" + ").includes(String(num)) ? '#fff' : '#000',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px'
                                    }}
                                    onClick={() => onChange(num.toString(), "receptionist")} // Khi click sẽ cập nhật giá trị vào staffCode
                                >
                                    {num}
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <div className="printer">------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------</div>
            <div className="printer">
                <div className="d-flex" style={{ flex: '10', width: '750px', marginBottom: '50px', marginTop: '24px' }}>
                    <div className="SI" style={{ flex: '9' }}>
                        <h1 className="SI_name no-printer" style={{ color: '#5f497a' }}>MAKE SERVICE INVOICE SYSTEM</h1>
                        <div className="SI_header d-flex justify-content-between mt-5" style={{ width: '1000px' }}>
                            <div className="d-flex">
                                <div style={{ width: '100%', }} align="right">
                                    <img
                                        style={{ width: '170px' }}
                                        src="https://database.azumayareport.com/img/logo/logo_az.png" 
                                        className="img-responsive logo"
                                        alt="image-logo" ></img>
                                </div>
                                <div style={{ textAlign: "left" }}>
                                    <div style={{ fontSize: '1.6rem', width: '300px', fontWeight: '500' }}>AZUMAYA {branchData.name.toUpperCase()} HOTEL</div>
                                    <div style={{ fontSize: '1.3rem', width: '400px' }}>Add: {branchData.address}</div>
                                    <div style={{ fontSize: '1.3rem' }}>Tel: {branchData.phone}</div>
                                </div>
                            </div>
                            <div style={{ fontSize: '2rem' }}>
                                <div>
                                    <span>Invoice Number:</span>
                                    <strong className={dataParams.idRoom ? "ml-2" : "ml-2 red-color"}>
                                        {dataParams.idRoom ? data.invoice_id :  "Waiting" }
                                    </strong>
                                    {dataParams.idRoom && <span style={{fontSize: '2rem', color: '#0066cc', marginLeft: '2px'}}>({data.version || 1})</span>}
                                </div>
                                <div className="no-print" style={{fontSize:"1.5rem", color: "#d800ff"}}>
                                    <span>(Late Invoice:</span>
                                    <strong className="ml-1"> {lateInvocie})</strong>
                                </div>
                            </div>
                        </div>
                        <div className="SI_name" style={{ fontSize: '3rem', fontWeight: '600' }}>SERVICE INVOICE</div>
                        {isView && versionHistory.length > 0 && (
                            <div className="no-print" style={{marginTop: '10px', marginBottom: '10px'}}>
                                <button className="btn btn-sm btn-outline-secondary" onClick={() => setShowVersionHistory(!showVersionHistory)}>
                                    {showVersionHistory ? 'Hide' : 'Show'} Version History ({versionHistory.length})
                                </button>
                                {showVersionHistory && (
                                    <div style={{marginTop: '10px', padding: '10px', backgroundColor: '#f0f0f0', borderRadius: '4px', maxHeight: '200px', overflowY: 'auto'}}>
                                        {versionHistory.map((v, idx) => (
                                            <div key={idx} style={{padding: '5px', borderBottom: '1px solid #ddd', cursor: 'pointer'}} 
                                                onClick={() => history.push(`/service_invoice/${branchID}/${v.invoice_id}/${v.version}`)}>
                                                <strong>V{v.version}</strong> - {new Date(v.createdAt).toLocaleString()} | {v.service} ({v.vnd || v.price})
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                        {!isView && <div className="no-print justify-content-center d-flex">
                            <input 
                                value={bookingId}
                                onChange={e => setBookingId(e.target.value)}
                                style={{width:"200px"}}
                                className="p-2"
                                placeholder="Enter booking id"
                            />
                            <button className="btn btn-success ml-2" 
                                onClick={() => loadDataGuestByRequest()}>Check Guest Data</button>
                        </div>}
                        <div className="SI_content">
                            <div className="SI_content-item">
                                <label className="label">Guest's name:</label>
                                <input className="input"
                                    disabled={isView}
                                    value={data.name.toLocaleUpperCase()}
                                    onChange={e => onChange(e.target.value, "name")} />

                                {!isView && <button className="no-print btn btn-primary" 
                                onClick={() => onChange("Visitor", "name", "changeVisitor")}>Visitor</button>}
                            </div>
                            <div className={data.name.toUpperCase() === "VISITOR" ? "op-hidden" : "SI_content-item"}>
                                <label className="label">Room number:</label>
                                <input className="input" value={data.room}
                                    disabled={isView}
                                    onChange={e => onChange(e.target.value, "room")} />
                            </div>
                            <div className="SI_content-item d-flex">
                                <label className="label" style={{width:"240px"}}>Service:</label>
                                <div className="service-wrapper">
                                    
                                    {/* Input gõ tự do */}
                                    <input
                                        className="input"
                                        disabled={isView}
                                        value={data.service}
                                        placeholder="Enter service..."
                                        onFocus={() => setShowServiceList(true)}
                                        onBlur={() => setTimeout(() => setShowServiceList(false), 120)}
                                        onChange={e => {
                                            onChange(e.target.value, "service");
                                            setFilterText(e.target.value.toLowerCase());
                                        }}
                                    />
                                    {/* Dropdown autocomplete */}
                                    {showServiceList && (
                                        <div className="service-grid">

                                            {/* Cột trái */}
                                            <div className="service-column">
                                                {listService.slice(0, 5)
                                                    .filter(item => item.value.toLowerCase().includes(filterText))
                                                    .map((item, index) => (
                                                        <div
                                                            key={index}
                                                            className="service-item"
                                                            onMouseDown={() => {
                                                        //     onChange(item.value, "service");
                                                                onChange(item.value, "service-item",item.price );
                                                                setFilterText("");
                                                            }}
                                                        >
                                                            {item.value} ({item.price.toLocaleString()})
                                                        </div>
                                                    ))
                                                }
                                            </div>

                                            {/* Cột phải */}
                                            <div className="service-column">
                                                {listService.slice(5)
                                                    .filter(item => item.value.toLowerCase().includes(filterText))
                                                    .map((item, index) => (
                                                        <div
                                                            key={index + 5}
                                                            className="service-item"
                                                            onMouseDown={() => {
                                                                onChange(item.value,  "service-item",item.price );
                                                                setFilterText("");
                                                            }}
                                                        >
                                                            {item.value} ({item.price})
                                                        </div>
                                                    ))
                                                }
                                            </div>

                                        </div>
                                    )}

                                </div>
                            </div>
                            {data.service.includes("Massage") && <div className="SI_content-item">
                                <label className="label">Staff Code:</label>
                                <input className="input"
                                    disabled={isView}
                                    value={data.staffCode}
                                    onChange={e => onChange(e.target.value, "staffCode")} />

                            </div>}

                            {!isView && data.service.includes("Massage") && (
                                <div className="number-btn-group" style={{ display: 'flex', gap: '5px', flexWrap: 'wrap',paddingLeft: '230px', paddingBottom: '2px' }}>
                                    {branchData.listStaffCodeMassage.map((num) => (
                                        <button
                                            key={num}
                                            type="button" // Tránh việc button tự động submit form nếu nằm trong thẻ <form>
                                            className="btn-quick-select no-print"
                                            style={{
                                                padding: '4px 8px',
                                                cursor: 'pointer',
                                                backgroundColor: String(data.staffCode) === String(num) ? '#007bff' : '#f0f0f0',
                                                color: String(data.staffCode) === String(num) ? '#fff' : '#000',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px'
                                            }}
                                            onClick={() => onChange(num.toString(), "staffCodeQuick")}
                                        >
                                            {num}
                                        </button>
                                    ))}
                                </div>
                            )}
                            
                            <div className="SI_content-item">
                                <label className="label">Price:</label>
                                <NumberFormat
                                    className="input"
                                    disabled={isView}
                                    thousandSeparator={true}
                                    type="text"
                                    min="0"
                                    value={data.price}
                                    onChange={e => onChange(e.target.value, "price")}
                                />
                            </div>
                            <div className={"SI_content-item"}>
                                <label className="label">Quantity:</label>
                                <NumberFormat
                                    className="input"
                                    disabled={isView}
                                    thousandSeparator={true}
                                    type="text"
                                    min="0"
                                    value={data.quantity}
                                    onChange={e => onChange(e.target.value, "quantity")}
                                />
                            </div>
                        </div>
                        <div className="SI_total">
                            <div style={{
                                // border: '1px solid black',
                                borderBottom: '0',
                                textAlign: 'left',
                                padding: '8px',
                                paddingLeft: '50px',
                                fontWeight: '600'
                            }}>TOTAL</div>
                            <div className="d-flex SI_total-content" style={{ flex: 9 }}>
                                <div style={{ flex: 2, border: '1px solid black', textAlign: 'left', paddingLeft: '50px', alignItems: 'center', borderRight: '0' }}>
                                    <div style={{ 
                                        fontWeight: '600', 
                                        margin: 'auto', 
                                        paddingRight: data.isDebit ? '' : '25px',
                                        paddingTop: data.isDebit  ? '41px' : '35%', 
                                    }}>PAYMENT TERM</div>
                                </div>

                                {
                                    data.isDebit ? <div style={{ flex: 7, borderTop: '1px solid', borderRight: '1px solid', borderLeft: '1px solid',   }}>
                                            <div className="SI_total-content-item" style={{ border: 0, borderBottom: '1px solid black' }}>
                                                <label className="label" style={{textAlign:'left', width: '120px', padding: '42px    '}}>DEBIT</label>
                                                <input
                                                    type="checkbox"
                                                    name="pay_method"
                                                    className="no-print"
                                                    checked={data.isDebit}
                                                    onChange={() => setDate({...data, isDebit: !data.isDebit})}
                                                    style={{ marginRight: "30px" }}
                                                />
                                            </div>

                                        </div> :
                                    <div style={{ flex: 7, border: '1px solid black' }}>

                                        {/* VND */}
                                        <div className="SI_total-content-item" style={{ border: 0, borderBottom: '1px solid black' }}>
                                            <label className="label">VND</label>

                                            <input
                                                type="radio"
                                                name="pay_method"
                                                className="no-print"
                                                checked={paymentMethod === "vnd"}
                                                onChange={() => handleSelectPayment("vnd")}
                                                style={{ marginRight: "10px" }}
                                            />

                                            <NumberFormat
                                                className="input"
                                                thousandSeparator={true}
                                                type="text"
                                                disabled={isView}
                                                value={data.vnd}
                                                onChange={e => onChange(e.target.value, "vnd")}
                                            />
                                        </div>

                                        {/* USD */}
                                        <div className="SI_total-content-item" style={{ border: 0, borderBottom: '1px solid black' }}>
                                            <label className="label">USD</label>

                                            <input
                                                type="radio"
                                                name="pay_method"
                                                className="no-print"
                                                checked={paymentMethod === "usd"}
                                                onChange={() => handleSelectPayment("usd")}
                                                style={{ marginRight: "10px" }}
                                            />

                                            <NumberFormat
                                                className="input"
                                                thousandSeparator={true}
                                                type="text"
                                                disabled={isView}
                                                value={data.usd}
                                                onChange={e => onChange(e.target.value, "usd")}
                                            />
                                        </div>

                                        {/* JPY */}
                                        <div className="SI_total-content-item" style={{ border: 0, borderBottom: '1px solid black' }}>
                                            <label className="label">JPY</label>

                                            <input
                                                type="radio"
                                                name="pay_method"
                                                className="no-print"
                                                checked={paymentMethod === "jpy"}
                                                onChange={() => handleSelectPayment("jpy")}
                                                style={{ marginRight: "10px" }}
                                            />

                                            <NumberFormat
                                                className="input"
                                                thousandSeparator={true}
                                                type="text"
                                                disabled={isView}
                                                value={data.jpy}
                                                onChange={e => onChange(e.target.value, "jpy")}
                                            />
                                        </div>

                                        {/* CREDIT CARD */}
                                        <div className="SI_total-content-item" style={{ border: 0, borderBottom: '1px solid black' }}>
                                            <label className="label">CREDIT CARD</label>

                                            <input
                                                type="radio"
                                                name="pay_method"
                                                className="no-print"
                                                checked={paymentMethod === "card"}
                                                onChange={() => handleSelectPayment("card")}
                                                style={{ marginRight: "10px" }}
                                            />

                                            <NumberFormat
                                                className="input"
                                                thousandSeparator={true}
                                                type="text"
                                                disabled={isView}
                                                value={data.card}
                                                onChange={e => onChange(e.target.value, "card")}
                                            />
                                        </div>

                                        {/* TRANSFER */}
                                        <div className="SI_total-content-item" style={{ border: 0, borderBottom: '1px solid black' }}>
                                            <label className="label">TRANSFER</label>

                                            <input
                                                type="radio"
                                                name="pay_method"
                                                className="no-print"
                                                checked={paymentMethod === "transfer"}
                                                onChange={() => handleSelectPayment("transfer")}
                                                style={{ marginRight: "10px" }}
                                            />

                                            <NumberFormat
                                                className="input"
                                                thousandSeparator={true}
                                                type="text"
                                                disabled={isView}
                                                value={data.transfer}
                                                onChange={e => onChange(e.target.value, "transfer")}
                                            />
                                        </div>

                                        {/* DEBIT */}
                                        <div className="SI_total-content-item no-print" style={{ border: 0 }}>
                                            <label className="label">DEBIT</label>

                                            <input
                                                type="checkbox"
                                                name="pay_method"
                                                className="no-print"
                                                checked={data.isDebit}
                                                onChange={() => setDate({...data, isDebit: !data.isDebit})}
                                                style={{ marginRight: "10px" }}
                                            />
                                        </div>

                                    </div>
                                }
                            </div>
                        </div>
                        <div className="SI_footer justify-content-between">
                            <div className="SI_footer-item">
                                <div className="d-flex">
                                    <label className="label">Date:</label>
                                    <input className="input no-printer" type="date" value={data.date}
                                        onChange={e => onChange(e.target.value, "date")}
                                        disabled={isView}
                                        style={{ width: '230px', textAlign: 'center' }} />
                                    <div className="input hidden printer" style={{ width: '230px', textAlign: 'center' }}>{data?.date}</div>
                                </div>
                                <div className="mt-4">
                                    <label className="label ">Receptionist:</label>
                                    <input className="input" value={data.receptionist} 
                                        onChange={e => setDate({...data, receptionist: e.target.value.toLocaleUpperCase()})}
                                        style={{textAlign: 'center'}} disabled={isView} />
                                </div>
                            </div>
                            <div className="SI_footer-item mt-4">
                                <label className="label" style={{ width: '40%' }}>Guest's signature:</label>
                                <input className="input" style={{ width: '70%' }} disabled={isView}/>
                            </div>
                        </div>

                        {!isView && (
                            <div className="number-btn-group" style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
                                {branchData.signature.map((num) => (
                                    <button
                                        key={num}
                                        type="button" // Tránh việc button tự động submit form nếu nằm trong thẻ <form>
                                        className="btn-quick-select"
                                        style={{
                                            padding: '4px 8px',
                                            cursor: 'pointer',
                                            backgroundColor: String(data.staffCode) === String(num) ? '#007bff' : '#f0f0f0',
                                            color: String(data.staffCode) === String(num) ? '#fff' : '#000',
                                            border: '1px solid #ccc',
                                            borderRadius: '4px'
                                        }}
                                        onClick={() => onChange(num.toString(), "receptionist")} // Khi click sẽ cập nhật giá trị vào staffCode
                                    >
                                        {num}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <FooterButton
                button1 = {undefined}//button1={data.edit ? "SAVE SERIVICE INVOICE" : undefined}
                button2={"PRINT / DOWN PDF"}
                button3={(dataParams.idRoom && data.version === data.lastVersion && !data.edit) ? "REQUEST EDIT" : undefined}
                button4={dataParams.idRoom ? "MAKE NEW" : undefined}

                iconBtn1="faSave" 
                iconBtn2="faPrint"
                iconBtn3={dataParams.idRoom ? "faEdit" : undefined}
                iconBtn4={dataParams.idRoom ? "faPrint" : undefined}

            //  width="1150px"
                onClickButton1={onSaveServiceInvoice}
                onClickButton2={onPrintNewNumberServiceInvoice}
                onClickButton3={onRequestEdit}
                onClickButton4={onPrintTranferNewLink}

            />
        </>)
}

export default MakeServiceInvoice
